import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { LangRouterService } from '@frontend/util-router-history';
import { CLIENT_DATA, DEPLOY_PREFIX } from '@frontend/util-api-data';
import { Store } from '@ngrx/store';
import { clearDownloadList } from '@frontend/data-access-download-list';
import { clearLandRole } from '@frontend/data-access-land-role';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private keycloak = inject(KeycloakService);
  private localizeService = inject(LangRouterService);
  private client = inject(CLIENT_DATA).name;
  private deployPrefix = inject(DEPLOY_PREFIX);
  private store = inject(Store);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.store.dispatch(clearDownloadList());
          this.store.dispatch(clearLandRole());
          const currentUrl = window.location.pathname + window.location.search + window.location.hash;

          if (this.client === 'jansen' || this.client === 'aks') {
            const loginPath = this.localizeService.translateRoute('/login') as string;
            // Nur weiterleiten, wenn nicht schon auf der Login-Seite
            if (!window.location.pathname.startsWith(loginPath)) {
              this.router.navigate([loginPath], {
                queryParams: { redirectUri: currentUrl },
              });
            }
          } else {
            this.keycloak.login({
              redirectUri: window.location.origin + this.deployPrefix + currentUrl,
            });
          }
        }
        if (error.status === 403) {
          const currentUrl = window.location.pathname + window.location.search + window.location.hash;
          this.router.navigate([this.localizeService.translateRoute('/access-denied') as string], {
            queryParams: { returnUrl: currentUrl },
          });
        }

        return throwError(() => error);
      })
    );
  }
}
